import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import copy from 'copy-to-clipboard';

import { Button } from '../../styled/form';
import { registerCopyPickupAddress } from '../../../services/reactGa';

interface CopyAddressButtonProps {
  address: string;
  className?: string;
  children: any;
}

const ButtonStyled = styled(Button)`
  display: inline-flex;
  justify-content: center;

  ${(props) => {
    // @ts-ignore
    const { isCopied, theme } = props;
    const { background, color } = isCopied ? theme.map.copied : theme.map.copy;

    return css`
      background: ${background};
      color: ${color};
    `;
  }};
`;

export const CopyAddressButton: React.FC<CopyAddressButtonProps> = React.memo(function ({
  address,
  className,
  children,
}) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyAddress = useCallback(() => {
    copy(address);
    registerCopyPickupAddress();
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1000);
  }, [address]);

  return (
    // @ts-ignore
    <ButtonStyled isCopied={isCopied} className={className} onClick={handleCopyAddress}>
      {children}
    </ButtonStyled>
  );
});
